import React from 'react'

export type TableCellAlign = 'left' | 'center' | 'right'

export interface TableCellProps {
  children: React.ReactNode
  align?: TableCellAlign
  truncate?: boolean
  className?: string
}

const alignmentStyles: Record<TableCellAlign, string> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
}

export const TableCell: React.FC<TableCellProps> = ({
  children,
  align = 'left',
  truncate = false,
  className = ''
}) => {
  return (
    <div
      className={`text-sm ${alignmentStyles[align]} ${
        truncate ? 'truncate overflow-hidden' : ''
      } ${className}`}
    >
      {children}
    </div>
  )
}
